import { Instance, types } from 'mobx-state-tree';
import { ICombiItem } from '../../comps/ItemDetail';
import { ISupplierItem } from '../../main/entities';
import { mg } from '../../mg/mg';

interface IAdOrderingItemKey {
	templateId: number
	advertisementId: number
	supplierItemId: number
}

export interface IAdOrderingItem extends IAdOrderingItemKey {
	supplierItem: ISupplierItem
	name: string
	imageLink: string
	supplierName: string
	amountToOrder: number
}

function eq(a: IAdOrderingItemKey, b: IAdOrderingItemKey) : boolean {
	if (a.templateId !== b.templateId) return false;
	if (a.advertisementId !== b.advertisementId) return false;
	if (a.supplierItemId !== b.supplierItemId) return false;
	return true;
}

export const AdOrderingStore = types
	.model('AdOrdering', {
		_list: types.array(types.frozen<IAdOrderingItem>()),
		dialogItem: types.maybe(types.frozen<ICombiItem>()),
	})
	.views(self => ({
		_findIndex(item: IAdOrderingItem) : number {
			return self._list.findIndex(i => eq(i, item));
		},
		byTemplateId(templateId: number) : Array<IAdOrderingItem> {
			return self._list.filter(i => i.templateId===templateId);
		},
	}))
	.views(self => ({
		has(item: IAdOrderingItem) : boolean {
			return self._findIndex(item) > -1;
		},
	}))
	.actions(self => ({
		add(item: IAdOrderingItem) : boolean {
			if (!mg.checkTrue(!self.has(item), 'AdOrderingStore', 'item already present')) return false;
			self._list.push(item);
			return true;
		},
		remove(item: IAdOrderingItem) : boolean {
			const i = self._findIndex(item);
			if (!mg.checkTrue(i >- 1, 'AdOrderingStore', 'item not found')) return false;
			self._list.splice(i, 1);
			return true;
		},
		onClick(item: IAdOrderingItem, e: any) {
			self.dialogItem = {
				amountStep: 1,
				isInvalid: false,
				...item.supplierItem!,
				advertisementId: item.advertisementId,
				templateId: item.templateId,
				supplierName: item.supplierName,
				imageLink: item.imageLink,
			};
			console.log('RRR', self.dialogItem, e);
		},
	}))
	.actions(self => ({
		_clearDialogItem() {
			self.dialogItem = undefined;
		},
		dialogItemDelete() {
			const di = self.dialogItem;
			if (!mg.assertPresent(di)) return;
			const item = self._list.filter(i => i.templateId===di.templateId && i.advertisementId===di.advertisementId)[0];
			if (!mg.assertPresent(item)) return;
			self.remove(item);
			self.dialogItem = undefined;
		},
	}))
	.views(self => ({
		get dialogItemState() {
			return {
				rowClick: (n: number) => self._clearDialogItem()
			};
		},
	}));

export type IAdOrderingStore = Instance<typeof AdOrderingStore>

export const adOrderingStore = AdOrderingStore.create({});
